import { PayloadAction } from '@reduxjs/toolkit';
import { EShortcutType } from '@shared/dto/hint_shortcuts/e_shortcut_type';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { STATE__ui } from '../STATE__ui';

export const local_ui_hint_shortcut_hide = (payload: EShortcutType): PayloadAction<EShortcutType> => ({
  type: ENUM__redux_action.UI_HINT_SHORTCUT_HIDE,
  payload,
});

export const init_local_ui_hint_shortcut_hide = (state: STATE__ui, action: PayloadAction<EShortcutType>) => {
  let key = action.payload;
  if (!state.hints_shortcut_visible.includes(key)) return; //already hidden

  state.hints_shortcut_visible = state.hints_shortcut_visible.filter(item => item !== key);
};
